module.exports = __webpack_public_path__ + "media/images/microsoft-exchange-1c49c85948f05eac1e03081b2a8119fe.svg";